import {
  Option,
  SelectBox,
  SelectBoxProps,
} from "@monolith-forensics/monolith-ui";
import { CasePriorities } from "../CasePriorities";

type CasePriorityRecord = {
  priority_id: number;
  priority_name: string;
};

export type CasePrioritySelectorProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchFn"
  | "onScroll"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

export const CasePrioritySelector: React.FC<CasePrioritySelectorProps> = (
  props
) => {
  const records: CasePriorityRecord[] = CasePriorities;

  // Combine number and name in label for client-side search by either
  const options: Option[] = records.map((item) => ({
    label: item.priority_name,
    value: item.priority_id,
    data: item,
  }));

  return (
    <SelectBox
      placeholder="Select or search for a case type..."
      {...props}
      data={options}
      searchable={false}
      renderOption={(option: Option | string) => {
        if (typeof option === "string") {
          return <div>{option}</div>;
        }

        const { data } = option;

        const IconComponent = data.icon;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <IconComponent size={16} style={{ color: data.color }} />
            <span>{data.priority_name}</span>
          </div>
        );
      }}
    />
  );
};
